import { render, staticRenderFns } from "./editBuildingView.vue?vue&type=template&id=294f80fb&scoped=true"
import script from "./editBuildingView.vue?vue&type=script&lang=js"
export * from "./editBuildingView.vue?vue&type=script&lang=js"
import style0 from "./editBuildingView.vue?vue&type=style&index=0&id=294f80fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294f80fb",
  null
  
)

export default component.exports